'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _helpersGetVrDevices = require('./helpers/get-vr-devices');

var _helpersGetVrDevices2 = _interopRequireDefault(_helpersGetVrDevices);

var _helpersPhonevr = require('./helpers/phonevr');

var _helpersPhonevr2 = _interopRequireDefault(_helpersPhonevr);

var _webgl = require('./webgl');

var _webgl2 = _interopRequireDefault(_webgl);

var _helpersManualControls = require('./helpers/manual-controls');

var _helpersManualControls2 = _interopRequireDefault(_helpersManualControls);

var _helpersGoFullScreen = require('./helpers/goFullScreen');

var _helpersGoFullScreen2 = _interopRequireDefault(_helpersGoFullScreen);

var noop = function noop() {};

var Video = (function (_React$Component) {
    _inherits(Video, _React$Component);

    function Video(props) {
        _classCallCheck(this, Video);

        _get(Object.getPrototypeOf(Video.prototype), 'constructor', this).call(this, props);

        this.state = {
            webGl: null,
            devices: null,
            needReload: false
        };
    }

    _createClass(Video, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(
                'div',
                null,
                _react2['default'].createElement(
                    'canvas',
                    { className: 'glcanvas', ref: 'canvas' },
                    'Your browser doesn\'t appear to support the HTML5 ',
                    _react2['default'].createElement(
                        'code',
                        null,
                        '<canvas>'
                    ),
                    ' element.'
                ),
                _react2['default'].createElement(
                    'video',
                    { preload: 'false', className: 'video', loop: 'true', 'webkit-playsinline': true, ref: 'video', style: { height: 200 } },
                    this.props.sources.map(function (s) {
                        return _react2['default'].createElement('source', { src: s.url, type: s.type, key: s.url });
                    })
                )
            );
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {}
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this = this;

            var devices = undefined;
            var phone = new _helpersPhonevr2['default']();

            (0, _helpersGetVrDevices2['default'])().then(function (devs) {
                console.log('devices: ', devs);
                devices = devs;
                _this.setState({ devices: devices });
            }).then(function () {
                return (0, _webgl2['default'])(devices, phone, _this.refs.video, _this.refs.canvas);
            }).then(function (gl) {
                _this.setState({ webGl: gl });
                (0, _helpersManualControls2['default'])(_this.props.keys, function (rotation, sign) {
                    gl.rotate(rotation, sign);
                });
            });

            var video = this.refs.video;

            video.addEventListener('timeupdate', function () {
                if (!video.paused) {
                    if (video.duration > 0) {
                        var value = video.currentTime / video.duration * 100;
                        _this.props.onPositionChange(value);
                    } else {
                        _this.props.onPositionChange(0);
                    }
                }
            });

            document.addEventListener('fullscreenchange', function (event) {
                if (this.props.isFullscreen !== document.fullscreenEnabled && document.fullScreenElement === this.refs.canvas) {
                    this.props.onFullscreen(document.fullscreenEnabled);
                }
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            if (this.props.sources != newProps.sources) {
                this.updateSources();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.state.needReload) {
                console.log('Reloading video');
                var video = this.refs.video;
                var webGl = this.state.webGl;
                video.load();
                webGl.draw();
                this.setState({ needReload: false });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var webGl = this.state.webGl;
            if (webGl) {
                webGl.stop();
            }
        }
    }, {
        key: 'playPause',
        value: function playPause() {
            var video = this.refs.video;
            var webGl = this.state.webGl;
            if (video.paused) {
                video.play();
                webGl.draw();
            } else {
                video.pause();
            }
            this.props.onPlayPause(!video.paused);
        }
    }, {
        key: 'toggleMute',
        value: function toggleMute() {
            var video = this.refs.video;
            video.muted = !video.muted;
            this.props.onMute(video.muted);
        }
    }, {
        key: 'goFullScreen',
        value: function goFullScreen() {
            var canvas = this.refs.canvas;
            var devices = this.state.devices;
            (0, _helpersGoFullScreen2['default'])(canvas, devices, true);
        }
    }, {
        key: 'setPosition',
        value: function setPosition(percentage) {
            var video = this.refs.video;
            var time = video.duration * percentage / 100;
            video.currentTime = time;
            this.props.onPositionChange(percentage);
        }
    }, {
        key: 'zeroSensor',
        value: function zeroSensor() {
            var devices = this.state.devices;
            if (devices.sensor) {
                devices.sensor.zeroSensor();
            }
        }
    }, {
        key: 'updateSources',
        value: function updateSources() {
            var video = this.refs.video;
            var webGl = this.state.webGl;
            video.pause();
            webGl.stop();
            this.props.onPlayPause(!video.paused);
            this.props.onPositionChange(0);
            this.setState({ needReload: true });
        }
    }]);

    return Video;
})(_react2['default'].Component);

Video.propTypes = {
    sources: _react.PropTypes.array.isRequired,
    onFullscreen: _react.PropTypes.func,
    onPositionChange: _react.PropTypes.func,
    onPlayPause: _react.PropTypes.func,
    onMute: _react.PropTypes.func,
    keys: _react.PropTypes.object
};

Video.defaultProps = {
    sources: [],
    onFullscreen: noop,
    onPositionChange: noop,
    onPlayPause: noop,
    onMute: noop,
    keys: {
        left: 'A',
        right: 'D',
        up: 'W',
        down: 'S',
        rotateLeft: 'Q',
        rotateRight: 'E',
        fullScreen: 'F',
        zeroSensor: 'Z',
        playPause: ' '
    }
};

exports['default'] = Video;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./~/babel-loader!./source/Video.jsx
 **/